import {
  Box,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";

export const PlanejamentoAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Planejamento
        </Text>
        {children}
      </Flex>

      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Plano de Trabalho?"}
          mb={4}
        >
          Possui Plano de Trabalho?
        </Text>
        <Field name="possuiPlano">
          {({ field, form }) => (
            <FormControl
              isInvalid={form.errors.possuiPlano && form.touched.possuiPlano}
              id="possuiPlano"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) => props.setFieldValue("possuiPlano", value)}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.possuiPlano}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Projeto Político-Pedagógico?"}
          mb={4}
        >
          Possui Projeto Político-Pedagógico?
        </Text>

        <Field name="possuiProjeto">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.possuiProjeto && form.touched.possuiProjeto
              }
              id="possuiProjeto"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("possuiProjeto", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.possuiProjeto}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Relatório Anual?"}
          mb={4}
        >
          Possui Relatório Anual?
        </Text>

        <Field name="possuiRelatorio">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.possuiRelatorio && form.touched.possuiRelatorio
              }
              id="possuiRelatorio"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("possuiRelatorio", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.possuiRelatorio}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Regimento Interno?"}
          mb={4}
        >
          Possui Regimento Interno?
        </Text>

        <Field name="possuiRegimento">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.possuiRegimento && form.touched.possuiRegimento
              }
              id="possuiRegimento"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("possuiRegimento", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.possuiRegimento}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
